import { Box, Button } from "@mui/material";
import type { ProductCode } from "Infrastructure/Api/Api";
import { toast } from "sonner";
import { useDeleteMerchantAppProductMutation } from "Api/Mutations/Merchants/useDeleteMerchantAppProductMutation";
import { Resources, useResource } from "Translations/Resources";

const COMPONENT_RESOURCES = Resources.Components.Merchant.AppProducts;

type Props = {
  merchantPublicID: string;
  productCode: ProductCode;
};

export const DeactivateProductButton = ({
  merchantPublicID,
  productCode,
}: Props) => {
  const { t } = useResource();

  const { mutate: removeProduct, isPending: isRemovingProduct } =
    useDeleteMerchantAppProductMutation({
      onError: () => {
        toast.error(t(COMPONENT_RESOURCES.Form.RemoveError));
      },
    });

  return (
    <Box display="flex" justifyContent="center" alignItems="center">
      <Button
        variant="text"
        color="error"
        size="medium"
        loading={isRemovingProduct}
        onClick={() => removeProduct({ merchantPublicID, productCode })}
      >
        {t(COMPONENT_RESOURCES.ProductAccordion.Deactivate)}
      </Button>
    </Box>
  );
};
